import React, { useEffect, useState } from "react"
import GooglePlay from "../../assets/img/google-play.inline.svg"
import AppStore from "../../assets/img/app-store.inline.svg"
import WebIcon from "../../assets/img/kuda-web.inline.svg"

import { currentYear } from "../../util/util"
import KudaLogo from "../../assets/img/kudabank-logo.inline.svg"
import KudaTwitter from "../../assets/img/twitter.inline.svg"
import KudaFacebook from "../../assets/img/facebook.inline.svg"
import KudaYoutube from "../../assets/img/youtube.inline.svg"
import KudaMedium from "../../assets/img/medium.inline.svg"
import KudaLinkedin from "../../assets/img/linkedin.inline.svg"
import KudaInstagram from "../../assets/img/instagram.inline.svg"
import { useLocation } from "@reach/router"
import NgGlobalOptions from "./ngGlobalOptions"
import UkOptions from "./ukOptions"

const Footer = () => {
  const location = useLocation()
  const [locationState, setLocation] = useState("")
  const [show, setShow] = useState(false)
  const [showFooter, setShowFooter] = useState(false)
  const [selectedItem, setSelectedItem] = useState("Global")
  const countryPathname = () => {
    const pathName = location.pathname
    setLocation(pathName)
  }

  useEffect(() => {
    if (location?.pathname.includes('/en-gb/')) {
      setSelectedItem('United Kingdom')
    }
    else if (location?.pathname.includes('/en-ca/')) {
      setSelectedItem('Canada')
    }
    else {
      setSelectedItem('Nigeria')
    }
  }, [location?.pathname])

  useEffect(() => {
    const pathName = location.pathname
    countryPathname()
    if (locationState.includes("/en-gb/")) {
      setLocation(pathName)
      setShow(true)
    } else if (
      locationState.includes("/") ||
      locationState.includes("/press/") ||
      locationState.includes("/faqs/") ||
      locationState.includes("/contact/")
    ) {
      setLocation(pathName)
    }
  }, [locationState])

  useEffect(() => {
    countryPathname()
    if (locationState.includes("/en-ng/")) {
      setShowFooter(true)
    }
  }, [locationState])
  return (
    <footer className="kuda-footer animated fadeInUp mb-5 py-4">
      <div className="container">
        <div className="kuda-footer--nav">
          <div className="kuda-footer--col">
            <div className="kuda-footer--brand">
              <KudaLogo />
            </div>
          </div>

          {(selectedItem === "Nigeria" || selectedItem === "Global" || selectedItem === "Canada") && (
            <NgGlobalOptions selectCountry={selectedItem}  pathName={location?.pathname}/>
          )}
          {selectedItem === "United Kingdom"  && <UkOptions />}
        </div>

        <div className="footer-download mb-4 pb-2">
          <div className="flex coming-soon--downloads">
            <div className="app-store">
              <a
                className="ios_app_store"
                href={"https://kuda.onelink.me/abUI/344e3dde/"}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Get Kuda app on Appstore"
              >
                <AppStore className="available" />
              </a>
            </div>
            <div className="google-play">
              <a
                className="google_play_store"
                href={`https://kuda.onelink.me/abUI/344e3dde/`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Get Kuda app on Google play store"
              >
                <GooglePlay className="available" />
              </a>
            </div>
            <div className="web">
              <a
                className="kuda_web"
                href="https://app.kuda.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Kuda on the Web"
              >
                <WebIcon className="available" />
              </a>
            </div>

            {/* <div className="ussd">
              <span>
                <img src={Ussd} alt="Kuda USSD Logo" />
              </span>
            </div> */}
          </div>
        </div>

        <div className="footer-product--vary color-primary">
          Products may vary by country or market.
        </div>

        <div className="footer-contact--information">
          <div className="information-col">
            <p className="footer-header text-bold color-primary">Contact</p>
            <div className="other-info">
              <div className="flex flex-column">
                {show ? (
                  <a
                    className="link-decoration color-primary text-bold"
                    href="mailto:helpuk@kuda.com"
                  >
                    helpuk@kuda.com
                  </a>
                ) : (
                  <a
                    className="link-decoration color-primary text-bold"
                    href="mailto:help@kuda.com"
                  >
                    help@kuda.com
                  </a>
                )}
                {/* <a
                  className="link-decoration color-primary text-bold pt-2"
                  href="mailto:whistleblower@kuda.com"
                >
                  whistleblower@kuda.com
                </a> */}
              </div>
              <div className="kuda-footer--connect">
                <div className="kuda-socials">
                  <ul>
                    <li>
                      <a
                        href="https://twitter.com/joinkuda/"
                        className="kuda-icon kuda-twitter"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="Kuda on Twitter"
                      >
                        <KudaTwitter />
                      </a>
                      <a
                        href="https://www.instagram.com/joinkuda/"
                        className="kuda-icon kuda-instagram"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="Kuda on Instagram"
                      >
                        <KudaInstagram />
                      </a>
                      <a
                        href="https://www.facebook.com/joinkuda/"
                        className="kuda-icon kuda-facebook"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="Kuda on Facebook"
                      >
                        <KudaFacebook />
                      </a>
                      <a
                        href="https://youtube.com/@joinkuda/"
                        className="kuda-icon kuda-youtube"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="Kuda on YouTube"
                      >
                        <KudaYoutube />
                      </a>
                      <a
                        href="https://joinkuda.medium.com/"
                        className="kuda-icon kuda-medium"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="Kuda on Medium"
                      >
                        <KudaMedium />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/joinkuda/"
                        className="kuda-icon kuda-linkedIn"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        aria-label="Kuda on LinkedIn"
                      >
                        <KudaLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="information-col">
            <p className="footer-header text-bold color-primary">Lagos</p>
            <div className="other-info">
              <p className="color-black">
                1-11 Commercial Avenue, Yaba, Lagos,
                <br />
                Nigeria
              </p>
            </div>
          </div>
          {!locationState.includes('kudamfb') && <>
        <div className="information-col">
            <p className="footer-header text-bold color-primary">London</p>
            <div className="other-info">
              <p className="color-black">
                5 New Street Square, <br /> London, EC4A 3TW, <br /> United
                Kingdom
              </p>
            </div>
          </div>
          <div className="information-col">
            <p className="footer-header text-bold color-primary">Cape Town</p>
            <div className="other-info">
              <p className="color-black">
                146 Campground Road, <br /> Snakepit Building, Level 4,
                Newlands, Cape Town
              </p>
            </div>
          </div>
          <div className="information-col">
            <p className="footer-header text-bold color-primary">Canada</p>
            <div className="other-info">
              <p className="color-black">
                3080 Yonge Street, <br /> Suite 6060, Toronto, <br /> Ontario
                M4N 3N1
              </p>
            </div>
          </div>
        </>}
        
        </div>

        <div className="kuda-footer--conditions">
          {showFooter && (
            <p className="mb-4">
              *Kuda Customers get 25 free transfer to other banks every month.
              Extra transfers to other banks cost ₦10 each.
              <br />
              **Kuda account holders can deposit money in over 10,000 branches
              across Nigeria for free.
            </p>
          )}

          <p className="mb-4">
            {` © ${currentYear()} Kuda Technologies Ltd (Company No.11472232). All rights reserved. `}
          </p>
          <p className="mb-4">
            If you would like to find out more about which Kuda entity you
            receive services from, please reach out to us via the in-app chat in
            the Kuda app. Nigerian banking services offered by Kuda Microfinance
            Bank (RC796975) with registered address at 1-11 Commercial Avenue,
            Yaba, Lagos, Nigeria. Kuda Microfinance Bank is licensed by the
            Central Bank of Nigeria. Deposits are insured by the Nigerian
            Deposit Insurance Corporation (NDIC).
          </p>
         {!locationState.includes('kudamfb') && <>
         <p className="mb-4">
            UK services are offered by Kuda EMI Ltd (Company No. 13724208) with
            registered address at 5 New Street Square, London, EC4A 3TW, United
            Kingdom.
          </p>
          <p>
            Canada services will be provided by Kuda Canada Technologies
            Limited, an Ontario corporation registered under number 1000286176,
            with its registered address located at 3080 Yonge Street, Suite
            6060, Toronto, Ontario M4N 3N1. Kuda Canada Technologies Limited is
            duly registered with The Financial Transactions and Reports Analysis
            Centre of Canada (FINTRAC) as a money service business, bearing
            registration number M23163015.
          </p>
         </>}
        </div>
      </div>
    </footer>
  )
}

export default Footer
